import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/components/AfterResultBot.css";
import omnicareLogo from "../../assets/icons/logo.svg";
import doctorImage from "../../assets/images/doctor.png";
import backIcon from "../../assets/icons/back.svg";
import LanguageSwitcher from "../LanguageSwitcher";
import sunIcon from "../../assets/icons/stars.svg";

const AfterQuiz3 = () => {
  const navigate = useNavigate();

  const handleFreePrograms = () => {
    // Fixme: Add a new page for free programs / even a google sheets with all the free programs
    window.open("https://docs.google.com/spreadsheets/d/1jcrrDwMKKHHwQteZhgZDE2t1GKAKHu7kpEWscxL9upo/edit?gid=0#gid=0", "_blank", "noopener,noreferrer");
  };

  const handleQuickConsult = () => {
    navigate("/after-quiz/4");
  };

  const handleBack = () => {
    navigate("/programs");
  };

  return (
    <div className="after-result-bot-container">
      {/* Header */}
      <header className="after-result-bot-header">
        <div className="logo-section">
          <div className="logo" onClick={() => navigate("/landing")} style={{ cursor: 'pointer' }}>
            <img src={omnicareLogo} alt="Pebble Health Logo" className="logo-icon" />
            <span className="logo-text">Pebble Health</span>
          </div>
        </div>
        <div className="header-actions">
          <LanguageSwitcher />
          <div className="back-button" onClick={handleBack}>
            <img src={backIcon} alt="Back" className="back-icon" />
          </div>
        </div>
      </header>

      {/* Doctor illustration above divider */}
      <div className="doctor-divider">
        <img src={doctorImage} alt="Dr. Sam" className="doctor-avatar" />
      </div>

      <div className="after-result-bot3-content">
        <h2 className="congrats-text">No healthcare provider yet? No worries, we've got you!</h2>
        <div className="info-row">
          <img src={sunIcon} alt="Sun" className="info-icon" />
          {/* fixme: check the price for online consultation */}
          <span>
            You might have free programs available in your area, or you can get a quick online consultation for as little as $20.
          </span>
        </div>
        <div className="after-result-bot3-buttons">
          <button type="button" className="answer-block answer-free" onClick={handleFreePrograms}>
            <div className="answer-title">I want to know about free programs!</div>
          </button>

          <button type="button" className="answer-block answer-consult" onClick={handleQuickConsult}>
            <div className="answer-title">I want a quick consultation</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AfterQuiz3;
